/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbRespRefineMenuFilterCategory_filters$ref = any;
export type SbRespRefineMenuFilterCategory_filters = ReadonlyArray<{
    readonly name: string | null;
    readonly values: ReadonlyArray<{
        readonly count: number | null;
        readonly urlLabel: string | null;
        readonly displayName: string | null;
        readonly linkReference: string | null;
        readonly linkable: boolean | null;
    } | null> | null;
    readonly " $refType": SbRespRefineMenuFilterCategory_filters$ref;
}>;



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbRespRefineMenuFilterCategory_filters",
    "type": "SearchBrowseFilter",
    "metadata": {
        "plural": true
    },
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "values",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchBrowseFilterValue",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "count",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "urlLabel",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "displayName",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "linkReference",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "linkable",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '132d468b2df21cc193997936513f8869';
export default node;
